import { urlContentRecords } from '../../api/urls';
import {
  apiGet,
  apiPost,
  apiDelete,
} from '../../api/index';

export function fetchFormDatas({ onSuccess, onError }) {
  return apiGet(`${urlContentRecords}/form_data`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchContentRecords({
  subjectPeriodId,
  pageInfo = { page: 1, pageSize: 15 },
  onSuccess,
  onError,
}) {
  return apiPost(`${urlContentRecords}/${subjectPeriodId}/all`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }

      if (onSuccess) onSuccess(res);

      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchContentRecord(id, { onSuccess, onError }) {
  return apiGet(`${urlContentRecords}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function saveContentRecord(user, { onSuccess, onError }) {
  return apiPost(`${urlContentRecords}`, user)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function deleteContentRecord(id, { onSuccess, onError }) {
  return apiDelete(`${urlContentRecords}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}
